import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { GetInvestigationTypesWithPagingQuery } from './get-investigation-types-with-paging.query';
import { GetInvestigationTypesWithPagingResult } from './get-investigation-types-with-paging.result';
import { InvestigationTypeState } from '../../states/investigation-type.state';

@Injectable({ providedIn: 'root' })
export class GetInvestigationTypesWithPagingUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(query: GetInvestigationTypesWithPagingQuery): Observable<GetInvestigationTypesWithPagingResult> {
    return this._repository.getInvestigationTypesWithPaging(query).pipe(
      map((result) => {
        this._state.setInvestigationTypes(result.data);
        this._state.setInvestigationTypesCount(result.totalElements);
        return {
          data: this._state.investigationTypes(),
          totalElements: result.totalElements,
        };
      }),
    );
  }
}
